import { registerQuery } from 'data-fetching-client';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';
export const AdEntityTypeToIdProperty = {
  AD: 'hs_ad_id',
  ADGROUP: 'hs_ad_group_id',
  CAMPAIGN: 'hs_ad_campaign_id',
  KEYWORD: 'hs_keyword_id'
};
const AdEntityTypeToObjectType = {
  AD: 'AD',
  ADGROUP: 'AD_GROUP',
  CAMPAIGN: 'AD_CAMPAIGN',
  KEYWORD: 'KEYWORD'
};
const AdNetworkToCrmAdNetwork = {
  ADWORDS: 'GOOGLE',
  LINKEDIN: 'LINKEDIN',
  FACEBOOK: 'FACEBOOK',
  ALL: 'ALL'
};
export const GET_ADS_PROPERTIES = registerQuery({
  fieldName: 'adsProperties',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('ads-list-seg/v1/interactions/list-seg-properties', {
      query: {
        portalId
      }
    });
  }
});
export const GET_ADS_PROPERTY_VALUES = registerQuery({
  fieldName: 'adsPropertyValues',
  args: ['portalId', 'adNetwork', 'entityType', 'ids'],
  fetcher({
    portalId,
    adNetwork,
    entityType,
    ids
  }) {
    return HttpClient.post('crm-search/search', {
      query: {
        portalId
      },
      data: {
        portalId,
        count: ids.length,
        offset: 0,
        requestOptions: {
          includeAllValues: true
        },
        sorts: [{
          property: 'hs_name',
          order: 'ASC'
        }],
        filterGroups: [{
          filters: [{
            property: 'hs_ad_network',
            value: AdNetworkToCrmAdNetwork[adNetwork],
            operator: 'EQ'
          }, {
            property: AdEntityTypeToIdProperty[entityType],
            values: ids,
            operator: 'IN'
          }]
        }],
        objectTypeId: AdEntityTypeToObjectType[entityType]
      }
    });
  }
});